module.exports = __webpack_public_path__ + "230be686477bbabfd124f94dd7e49de7.png";